import { ReactNode } from 'react';

import { Box, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR } from 'date-fns/locale';

import { Row } from 'components/form';
import { Block } from 'components/page';
import { SubTitle } from 'components/text';

type FilterDesktop = {
    children?: ReactNode;
    fixed?: boolean;
    loadingSubmit?: boolean;
    reset: () => void;
    submit: () => void;
};

export function FilterDesktop({ children, fixed = true, loadingSubmit = false, reset, submit }: FilterDesktop) {
    const style = fixed ? { position: 'sticky', top: 8, zIndex: 3 } : {};

    return (
        <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns}>
            <Block sx={style}>
                <SubTitle label="Filtros" />

                <Row sx={{ '& .MuiGrid-root:empty': { display: 'none' } }}>{children}</Row>

                <Box sx={{ display: 'flex', alignItems: 'stretch', justifyContent: 'flex-end', gap: 2 }}>
                    <Button onClick={reset}>Redefinir</Button>

                    <Button variant="contained" onClick={submit} loading={loadingSubmit}>
                        Pesquisar
                    </Button>
                </Box>
            </Block>
        </LocalizationProvider>
    );
}
